import { ColorScales } from '../../../types/theme';
import { getColorScaleAsArray } from './getColorScaleAsArray';

export const utils = {
  colorScales: ColorScales,
  getColorScaleAsArray,
};
